import React, { useContext } from 'react';

export const GlobalErrorHandler = ({ error, context }) => {
  const { toFalse } = useContext(context);

  return (
    <div>
      <p>{error}</p>
      <div className='cncl-btn'>
        <i
          className='fas fa-times'
          onClick={() => toFalse('SET_GLOBAL_ERROR')}
        ></i>
      </div>
    </div>
  );
};
